/* Copyright (c) 2020-present CloudIO Inc */

import { Box, IconButton, Typography } from '@mui/material';
import { CustomDomComponent, motion } from 'framer-motion';
import type { BoxProps, IconButtonProps, TypographyProps } from '@mui/material';

export const MotionIconButton: CustomDomComponent<IconButtonProps> =
  motion(IconButton);

export const MotionBox: CustomDomComponent<BoxProps> = motion(Box);

export const MotionTypography: CustomDomComponent<TypographyProps> =
  motion(Typography);
